module.exports = __webpack_public_path__ + "static/shessuch-969b464318a1499527bb2c838bccbbae.jpg";